namespace Matrix.Data {
    export interface FxRateRow {
        FromCurrency?: string;
        ToCurrency?: string;
        SourceCode?: string;
        InstanceCode?: string;
        AsAtDate?: string;
        RateMultiplier?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace FxRateRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'FromCurrency';
        export const localTextPrefix = 'Data.FxRate';
        export const deletePermission = 'DataAdmin:ReadOnly';
        export const insertPermission = 'DataAdmin:ReadOnly';
        export const readPermission = 'DataAdmin:ReadOnly';
        export const updatePermission = 'DataAdmin:ReadOnly';

        export declare const enum Fields {
            FromCurrency = "FromCurrency",
            ToCurrency = "ToCurrency",
            SourceCode = "SourceCode",
            InstanceCode = "InstanceCode",
            AsAtDate = "AsAtDate",
            RateMultiplier = "RateMultiplier",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
